import React from "react"
import autobind from "class-autobind"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import strings from "../../../localization/strings"
import ImageLoader from "../../../components/misc/ImageLoader"
import PayrollTimeByHierarchyEmployeeDayRow from "./PayrollTimeByHierarchyEmployeeDayRow"
import PayrollByHierarchyEmployeeRowExportedColumn from "../../../components/payroll/PayrollByHierarchyEmployeeRowExportedColumn"
import { browserHistory } from "react-router"
import { IPayrollTimeHierarchyEmployee, ITimeTotals, EPunchSetApprovalType, IPayrollPunchSet, IExpensesPayrollData, IPayrollTime, ILockedObjData, IDateRange, IPayrollLockedData } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import ApproveIcon from "../../../components/approve/ApproveIcon"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AppStateStore from "../../../stores/AppStateStore"
import * as api from "../../../api"
import { grey50, deepOrangeA700 } from "material-ui/styles/colors"
import PayrollByHierarchyTableLockedColumn from "../../../components/payroll/PayrollByHierarchyTableLockedColumn"

interface IProps {
	viewPayrollByJob: boolean
	payrollDates: IDateRange
	employees: IPayrollTimeHierarchyEmployee[]
	payrollHierarchyLockedData?: IPayrollLockedData
	timeTotals: ITimeTotals
	expandState: boolean
	payrollHierarchyIndex: number
	showTimecardPopup(employeeId: string, referenceDate: string): void
	handleSelectEmployee?(payrollHierarchyIndex: number, selectedEmployees: IPayrollTimeHierarchyEmployee[], unselectedEmployees: IPayrollTimeHierarchyEmployee[]): void
	reloadTimeCard: () => void
}
interface IState {
	expandRow: number
	selectedEmployees: IPayrollTimeHierarchyEmployee[]
}

export default class PayrollTimeByHierarchyEmployeeRow extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			expandRow: -1,
			selectedEmployees: []
		}
		autobind(this)
	}
	handleSelectEmployee(rows) {
		if (!this.props.handleSelectEmployee) return
		const selectedEmployees = []
		rows.forEach((row) => selectedEmployees.push(this.props.employees[row]))
		this.setState({ selectedEmployees })
		const unselectedEmployees = []
		this.props.employees.forEach((item) => {
			if (!selectedEmployees.find((selectedItem) => selectedItem.EmployeeId === item.EmployeeId)) {
				unselectedEmployees.push(item)
			}
		})
		this.props.handleSelectEmployee(this.props.payrollHierarchyIndex, selectedEmployees, unselectedEmployees)
	}

	getMissingPunchCount(employeeData: IPayrollTimeHierarchyEmployee) {
		let missingPunchCount = 0
		employeeData.JobCostingSummaryList.forEach(dayData => {
			dayData.PayrollPunchSets.forEach((punchSet) => {
				if (!punchSet.PunchOutId) missingPunchCount++
			})
		})
		return missingPunchCount
	}

	onClickEmployeeImgCol(e, userId: string) {
		e.stopPropagation()
		if (!permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.ViewEmployees)) return
		api.checkUserDeleted(userId).then(res =>
			res.data ?
				AppStateStore.setProgressSnackbarContent(strings.This_employee_has_been_deleted) :
				browserHistory.push("/user-details/" + userId + "/timecards")
		)
	}



	render() {
		const { employees, timeTotals } = this.props
		const { expandRow } = this.state
		var formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
		})
		const selectable = this.props.handleSelectEmployee ? true : false
		return (
			<div>
				{this.props.expandState &&
					<Table style={{ backgroundColor: "none" }} selectable={selectable} multiSelectable={selectable} onRowSelection={this.handleSelectEmployee}>
						<TableHeader displaySelectAll={false} adjustForCheckbox={selectable}>
							<TableRow className={selectable ? "ShortSelectBoxTableHeader" : null}>
								<TableHeaderColumn style={styles.imageCol} />
								<TableHeaderColumn className="TextOverflow" title={strings.Employee} style={styles.employeeCol}>{strings.Employee}</TableHeaderColumn>
								{AccountStore.getShowPayrollRates() &&
									<TableHeaderColumn className="TextOverflow" title={`${strings.Pay} ${strings.Amount}`} style={styles.amountCol}>{strings.Pay} {strings.Amount}</TableHeaderColumn>
								}
								{AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() &&
									<TableHeaderColumn className="TextOverflow" title={strings.Amount} style={styles.amountCol}>{strings.Amount}</TableHeaderColumn>
								}
								<TableHeaderColumn className="TextOverflow" title={strings.Total} style={styles.hoursCol}>{strings.Total}</TableHeaderColumn>
								<TableHeaderColumn className="TextOverflow" title={strings.RegularHours} style={styles.hoursCol}>{strings.RegularHours}</TableHeaderColumn>
								<TableHeaderColumn className="TextOverflow" title={strings.OvertimeHours} style={styles.hoursCol}>{strings.OvertimeHours}</TableHeaderColumn>
								{!AccountStore.getHideOT2() &&
									<TableHeaderColumn className="TextOverflow" title={strings.DoubleOvertimeHours} style={styles.hoursCol}>{strings.DoubleOvertimeHours}</TableHeaderColumn>
								}
								{timeTotals.PayTypeTotals.map((payTypeTotal, index) =>
									<TableHeaderColumn key={index} className="TextOverflow" style={styles.hoursCol} title={payTypeTotal.PayTypeName}>{payTypeTotal.PayTypeCode}</TableHeaderColumn>
								)}
								<TableHeaderColumn className="TextOverflow" title={strings.Open_Punches} style={styles.missingPunchedCol}>{strings.Open_Punches}</TableHeaderColumn>
								{AccountStore.getEmployeeApproveTimecardEnabled() &&
									<TableHeaderColumn className="TextOverflow" title={strings.Employee} style={styles.approvedCol}>{strings.Employee}</TableHeaderColumn>
								}
								<TableHeaderColumn className="TextOverflow" title={strings.Supervisor} style={styles.approvedCol}>{strings.Supervisor}</TableHeaderColumn>
								{AccountStore.getExtSupApproveTimecardEnabled() &&
									<TableHeaderColumn className="TextOverflow" title={strings.External} style={styles.approvedCol}>{strings.External}</TableHeaderColumn>
								}
								<TableHeaderColumn className="TextOverflow" title={strings.Validation_msgs} style={{ ...styles.approvedCol, width: 100 }}>{strings.Validation_msgs}</TableHeaderColumn>
								{!this.props.viewPayrollByJob &&
									<TableHeaderColumn className="TextOverflow" title={strings.Locked} style={styles.exportedCol}>{strings.Locked}</TableHeaderColumn>
								}
								{!this.props.viewPayrollByJob &&
									<TableHeaderColumn className="TextOverflow" title={strings.Exported} style={styles.exportedCol}>{strings.Exported}</TableHeaderColumn>
								}
							</TableRow>
						</TableHeader>
						<TableBody deselectOnClickaway={false} displayRowCheckbox={selectable}>
							{employees.map((employeeData, index) => {
								const selected = this.state.selectedEmployees.find((item) => item.EmployeeId === employeeData.EmployeeId) ? true : false
								let bold = true
								const allPunchsets: IPayrollPunchSet[] = []
								const allExpenses: IExpensesPayrollData[] = []
								employeeData.JobCostingSummaryList.forEach(jcsItem => {
									jcsItem.PayrollPunchSets && jcsItem.PayrollPunchSets.forEach(psItem => allPunchsets.push(psItem))
									jcsItem.PayrollExpenses && jcsItem.PayrollExpenses.forEach(exItem => allExpenses.push(exItem))
									if ((jcsItem.PayrollPunchSets && jcsItem.PayrollPunchSets.length > 0) ||
										jcsItem.PayrollExpenses && jcsItem.PayrollExpenses.length > 0
									)
										bold = false
								})
								const individualLockedData: ILockedObjData = this.props.payrollHierarchyLockedData &&
									this.props.payrollHierarchyLockedData.LockedObjData &&
									this.props.payrollHierarchyLockedData.LockedObjData.find(i => i.LockedObjId === employeeData.EmployeeId)

								return (
									<TableRow key={index} className={selectable ? "ShortSelectBoxTableRow" : null} selected={selected}>
										<TableRowColumn style={{ paddingLeft: 0, paddingRight: 0 }}>
											<Table
												style={{ backgroundColor: "none" }}
												onCellClick={() => this.setState({ expandRow: index === this.state.expandRow ? -1 : index })}
											>
												<TableBody displayRowCheckbox={false}>
													<TableRow data-intercom-target={index === 0 && "menu-Payroll-PayrollTimeHierarchyTable-openEmployeeRowDetails"} style={{ cursor: "pointer", height: 48, borderBottom: index === expandRow ? "solid 1px rgb(204, 204, 204)" : "none" }}>
														<TableRowColumn style={styles.imageCol}>
															{employeeData.ProfileImageS3Url &&
																<div
																	onClick={e => this.onClickEmployeeImgCol(e, employeeData.EmployeeId)}
																	style={{ cursor: "pointer" }}
																>
																	<ImageLoader url={employeeData.ProfileImageS3Url} fixedHeight={75} avatar={true} />
																</div>
															}
														</TableRowColumn>
														<TableRowColumn style={{ ...styles.employeeCol, fontWeight: bold && "bolder" }}>{`${employeeData.FirstName} ${employeeData.LastName}`}
															<br></br>
															<span style={{ color: "rgb(158, 158, 158)", fontSize: 10 }}>Emp #: {employeeData.ExternalId}</span>
														</TableRowColumn>
														{AccountStore.getShowPayrollRates() &&
															<TableRowColumn style={{ ...styles.amountCol, fontWeight: bold && "bolder" }}>{formatter.format(employeeData.TimeTotals.TotalPay)}</TableRowColumn>
														}
														{AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() &&
															<TableRowColumn style={{ ...styles.amountCol, fontWeight: bold && "bolder" }}>{formatter.format(employeeData.TimeTotals.TotalAmount)}</TableRowColumn>
														}
														<TableRowColumn style={{ ...styles.hoursCol, fontWeight: bold && "bolder" }}>{employeeData.TimeTotals && employeeData.TimeTotals.TotalProductiveHours}</TableRowColumn>
														<TableRowColumn style={{ ...styles.hoursCol, fontWeight: bold && "bolder" }}>{employeeData.TimeTotals && employeeData.TimeTotals.RegularHours}</TableRowColumn>
														<TableRowColumn style={{ ...styles.hoursCol, fontWeight: bold && "bolder" }}>{employeeData.TimeTotals && employeeData.TimeTotals.OvertimeHours}</TableRowColumn>
														{!AccountStore.getHideOT2() &&
															<TableRowColumn style={{ ...styles.hoursCol, fontWeight: bold && "bolder" }}>{employeeData.TimeTotals && employeeData.TimeTotals.DoubleOvertimeHours}</TableRowColumn>
														}
														{timeTotals.PayTypeTotals.map((payTypeTotalCol, index) => {
															const payTypeTotal = employeeData.TimeTotals.PayTypeTotals.find(item => item.PayTypeId === payTypeTotalCol.PayTypeId)
															return (
																<TableRowColumn style={styles.hoursCol} key={index}>{payTypeTotal && payTypeTotal.TotalHours}</TableRowColumn>
															)
														})}
														<TableRowColumn style={{ ...styles.missingPunchedCol, fontWeight: bold && "bolder" }}>{this.getMissingPunchCount(employeeData)}</TableRowColumn>
														{AccountStore.getEmployeeApproveTimecardEnabled() &&
															<TableRowColumn style={styles.approvedCol}>
																<ApproveIcon
																	identify={`Time_EmployeeRowEmpApprove${index}`}
																	toolTipPosition="bottom"
																	toolTipArrow="center"
																	approvalType={EPunchSetApprovalType.Employee}
																	width={14}
																	punchSets={allPunchsets}
																	expenses={allExpenses}
																/>
															</TableRowColumn>
														}
														<TableRowColumn style={styles.approvedCol}>
															<ApproveIcon
																identify={`Time_EmployeeRowApprove${index}`}
																toolTipPosition="bottom"
																toolTipArrow="center"
																approvalType={EPunchSetApprovalType.Supervisor}
																width={18}
																punchSets={allPunchsets}
																expenses={allExpenses}
															/>
														</TableRowColumn>
														{AccountStore.getExtSupApproveTimecardEnabled() &&
															<TableRowColumn style={styles.approvedCol}>
																<ApproveIcon
																	identify={`Time_EmployeeRowExtSupApprove${index}`}
																	toolTipPosition="bottom"
																	toolTipArrow="center"
																	approvalType={EPunchSetApprovalType.ExtSupervisor}
																	width={14}
																	punchSets={allPunchsets}
																	expenses={[]}
																/>
															</TableRowColumn>
														}
														<TableRowColumn style={{ ...styles.approvedCol, width: 100 }}>
															{employeeData.TimecardValidations.reduce((prev, curr) => prev + (curr.Validations || []).length, 0) ? <div
																style={{
																	fontSize: 14, fontWeight: 500,
																	paddingLeft: 5, paddingRight: 5,
																	minWidth: 20, height: 20, marginLeft: "auto", marginRight: "auto", maxWidth: 30,
																	backgroundColor: deepOrangeA700, color: grey50, borderRadius: 100, textAlign: "center", zIndex: 100
																}}
																onClick={() => AppStateStore.setNoteDrawerContent({
																	drawerTitle: `${employeeData.FirstName} ${employeeData.LastName} - ${strings.Payroll} ${strings.Notes}`,
																	objectData: { ObjectId: employeeData.PayrollPayGroupId },
																	objectName: `${employeeData.FirstName} ${employeeData.LastName}`,
																	dataType: "payroll",
																	validationMessages: employeeData.TimecardValidations.reduce((acc, tc) => acc.concat(tc.Validations), []),
																	readValidationMessage: async (msgeId: string) => {
																		const res = await api.readValidationMessage(employeeData.EmployeeId, msgeId, employeeData.TimecardValidations[0].TimecardStartDate)
																		this.props.reloadTimeCard()
																		return res.data
																	}
																})}
															>
																{employeeData.TimecardValidations.reduce((prev, curr) => prev + curr.Validations.length, 0) || null}
															</div> : <div style={{ minWidth: 20, height: 20, marginLeft: "auto", marginRight: "auto", maxWidth: 30, }}></div>}
														</TableRowColumn>
														{!this.props.viewPayrollByJob &&
															<TableRowColumn style={styles.exportedCol}>
																{individualLockedData &&
																	<PayrollByHierarchyTableLockedColumn
																		keyStr={`payrolltimehierarchyemployee${index}`}
																		lockedData={individualLockedData}
																	/>
																}
															</TableRowColumn>
														}
														{!this.props.viewPayrollByJob &&
															<TableRowColumn style={styles.exportedCol}>
																{employeeData.ExportedBy &&
																	<PayrollByHierarchyEmployeeRowExportedColumn
																		keyStr={`time${index}`}
																		exported={employeeData.Exported}
																		exportNote={employeeData.ExportNote}
																		exportedDate={employeeData.ExportedDate}
																		exportedBy={employeeData.ExportedBy}
																	/>
																}
															</TableRowColumn>
														}
													</TableRow>
													{index === expandRow &&
														<TableRow>
															<TableRowColumn
																colSpan={8 +
																	(AccountStore.getHideOT2() ? 0 : 1) +
																	(timeTotals && timeTotals.PayTypeTotals ? timeTotals.PayTypeTotals.length : 0) +
																	(AccountStore.getEmployeeApproveTimecardEnabled() ? 1 : 0) +
																	(AccountStore.getExtSupApproveTimecardEnabled() ? 1 : 0) +
																	(AccountStore.getShowPayrollRates() ? 1 : 0) +
																	(AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() ? 1 : 0) +
																	(this.props.viewPayrollByJob ? 0 : 1)
																}
																style={{ paddingLeft: 20, paddingBottom: 40, paddingTop: 40, paddingRight: 0 }}
															>
																<div onClick={(e) => e.stopPropagation()}>
																	<PayrollTimeByHierarchyEmployeeDayRow
																		payrollDates={this.props.payrollDates}
																		daysData={employeeData.JobCostingSummaryList}
																		timeTotals={employeeData.TimeTotals}
																		employeeId={employeeData.EmployeeId}
																		showTimecardPopup={this.props.showTimecardPopup}
																	/>
																</div>
															</TableRowColumn>
														</TableRow>
													}
												</TableBody>
											</Table>
										</TableRowColumn>
									</TableRow>
								)
							})}
						</TableBody>
					</Table>
				}
			</div>
		)
	}
}

const styles = {
	imageCol: {
		width: 45,
		textAlign: "center",
		paddingLeft: 5,
		paddingRight: 5
	},
	approvedCol: {
		width: 60,
		textAlign: "center",
		paddingLeft: 5,
		paddingRight: 5
	},
	employeeCol: {
		width: 150,
		paddingLeft: 10,
		paddingRight: 10
	},
	exportedCol: {
		width: 150,
		textAlign: "center",
		paddingLeft: 10,
		paddingRight: 10
	},
	missingPunchedCol: {
		width: 80,
		paddingLeft: 10,
		paddingRight: 10
	},
	hoursCol: {
		paddingLeft: 10,
		paddingRight: 10,
	},
	amountCol: {
		width: 80,
		paddingLeft: 10,
		paddingRight: 10
	}
}
